import React, { useState } from "react";
import { NAV_FOOTER } from "../helpers/navCatalog.generated";
import { trackNewsletterSubscribed } from "../helpers/analytics";
import { useAuth } from "../helpers/useAuth";
import styles from "./AppFooter.module.css";

interface AppFooterProps {
  className?: string;
}

export const AppFooter = ({ className }: AppFooterProps) => {
  const currentYear = new Date().getFullYear();
  // La newsletter s'adresse au visiteur sans compte : un membre la règle depuis son compte.
  const { authState } = useAuth();
  const visiteur = authState.type === "unauthenticated";
  const [nlEmail, setNlEmail] = useState("");
  const [nlStatus, setNlStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [nlMessage, setNlMessage] = useState("");

  const handleNewsletterSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nlEmail.trim()) return;
    setNlStatus("loading");
    try {
      const res = await fetch("/_api/public/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: nlEmail.trim() }),
      });
      const data = await res.json();
      if (data.success) {
        setNlStatus("success");
        trackNewsletterSubscribed("pied_de_page");
        setNlMessage("Inscription confirmée !");
        setNlEmail("");
      } else {
        setNlStatus("error");
        setNlMessage(data.error || "Une erreur est survenue.");
      }
    } catch {
      setNlStatus("error");
      setNlMessage("Erreur réseau, réessayez.");
    }
  };

  return (
    <footer className={`km-ft ${className || ""}`} role="contentinfo" data-nav-emplacement="pied">
      <div className="km-ft__in">
              <div className="km-ft__cols">
                {NAV_FOOTER.columns.map((col) => (
                  <div key={col.key} className="km-ft__col">
                    <a className="km-ft__head" href={col.hubPath} data-nav-rubrique={col.key}>{col.label}</a>
                    <ul>{col.links.map((l) => <li key={l.href}><a href={l.href} data-nav-rubrique={col.key}>{l.label}</a></li>)}</ul>
                  </div>
                ))}
                <div className="km-ft__col">
                  <span className="km-ft__head">KenoMetric</span>
                  <ul>{NAV_FOOTER.kenometric.map((l) => <li key={l.href}><a href={l.href} data-nav-rubrique="kenometric">{l.label}</a></li>)}</ul>
                </div>
                <div className="km-ft__col">
                  <span className="km-ft__head">Légal</span>
                  <ul>{NAV_FOOTER.legal.map((l) => <li key={l.href}><a href={l.href} data-nav-rubrique="kenometric">{l.label}</a></li>)}</ul>
                </div>
              </div>

        {/* Newsletter, visiteur sans compte seulement */}
        {visiteur && (
        <div className={styles.newsletter}>
          <h4 className={styles.newsletterTitle}>Recevez l'analyse du tirage chaque soir</h4>
          <form className={styles.newsletterForm} onSubmit={handleNewsletterSubmit}>
            <input
              type="email"
              className={styles.newsletterInput}
              placeholder="votre@email.fr"
              value={nlEmail}
              onChange={(e) => setNlEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <button
              type="submit"
              className="km-btn"
              disabled={nlStatus === "loading"}
            >
              {nlStatus === "loading" ? "…" : "S'inscrire"}
            </button>
          </form>
          {nlStatus !== "idle" && nlStatus !== "loading" && (
            <p className={nlStatus === "success" ? styles.newsletterSuccess : styles.newsletterError}>
              {nlMessage}
            </p>
          )}
        </div>
        )}

        <div className="km-ft__legal">
          <a href="/" className="km-ft__logo"><img src="/logo-banner.webp" alt="KenoMetric" width={148} height={36} loading="lazy" decoding="async" /></a>
          <p>Analyse statistique du Keno FDJ, à partir des résultats officiels. Site indépendant de la FDJ, sans offre de jeu.</p>
          <p>Le Keno est un jeu d'argent, interdit aux mineurs. Jouez avec modération. Aide : <a href="tel:0974751313">09 74 75 13 13</a> · <a href="https://www.joueurs-info-service.fr/" target="_blank" rel="noopener noreferrer">joueurs-info-service.fr</a></p>
          <p className="km-ft__copy">© {currentYear} KenoMetric</p>
        </div>
      </div>
    </footer>
  );
};
